import { nzTodayIso } from "@/lib/dates";
export const NEED_TYPES = { order: "Order materials", collect: "Collect from yard", other: "Other crew needs" };
export const needType = item => NEED_TYPES[item.request_type] ? item.request_type : "other";
export function neededLabel(item) {
  if (!item.needed_on) return "No date set";
  const today = nzTodayIso();
  if (item.needed_on === today) return "Needed today";
  const label = new Date(`${item.needed_on}T12:00:00`).toLocaleDateString("en-NZ", { day: "numeric", month: "short" });
  return `${!item.done && item.needed_on < today ? "Overdue · " : "Needed "}${label}`;
}
export const sortNeeds = (a, b) => (a.needed_on || "9999").localeCompare(b.needed_on || "9999") || (a.created_at || "").localeCompare(b.created_at || "");
